/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "../assets/css/style.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import imgurl from "../assets/images/imgurl";
import Filter from "../components/Filter";
import ShimmerLoader from "../components/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
import Charts from "./Charts";
import API from "../services/apiMiddleware";
import { getUsersCounters, getRoleDetails } from "../services/urls";
import { setRoleInfoData } from "../redux/actions/roleInfo";
import { heIL } from "@mui/x-date-pickers/locales";

function Overview() {
  const [overviewData, setOverviewData] = useState(0);
  const [isPayload, setIsPayload] = useState({});

  const chartNames = {
    chartOne: "Onboarding Trend",
    chartTwo: "Distribution of diagnosed condition",
    chartThree: "Disaggregation by District and RHC",
    chartFour: "Medical Emergencies",
    chartFive: "User Response Rate",
  };

  const dispatch = useDispatch();
  const globalFilters = useSelector(
    (state) => state.filterPayload.globalFilters
  );
  const communityId = useSelector((state) => state.communityData.communityId);
  const roleId = useSelector((state) => state.communityData.roleId);


  useEffect(() => {

    if (globalFilters != null) {
      fetchOverviewData(globalFilters);
    }

    let requestBody = {
      communityId,
    };

    if (globalFilters != null) {
      requestBody = { ...requestBody, globalFilters };
    }
    setIsPayload(requestBody);
  }, [globalFilters]);

  const fetchOverviewData = async (filterPayload) => {
    let requestBody = {
      communityId,
    };

    if (filterPayload && Object.keys(filterPayload).length > 0) {
      requestBody.globalFilters = filterPayload;
    }
    API.post(getUsersCounters, requestBody)
      .then(({ data }) => {
        const overviewResponseData = data.data;
        setOverviewData(overviewResponseData);
      })
      .catch((error) => {
        console.error("Error fetching user counters data:", error);
      });
  };

  return (
    <>
      <div className="mainSection">
        <div className="Overview">
          <Card className="overviewcard">
            <CardContent className="overviewcardcontent">
              <Typography>
                Total number of people onboarded on the platform
              </Typography>
              <div className="cardinfosec">
                <div className="imgbg">
                  <img src={imgurl.icon1}></img>
                </div>

                <Typography className="count shimmer-loader">
                  {overviewData ? (
                    overviewData.numberOfGuestUsersAndApplicants
                  ) : (
                    <ShimmerLoader></ShimmerLoader>
                  )}
                </Typography>
              </div>
            </CardContent>
          </Card>

          <Card className="overviewcard">
            <CardContent className="overviewcardcontent">
              <Typography>Total people not answered all questions</Typography>
              <div className="cardinfosec">
                <div className="imgbg">
                  <img src={imgurl.icon3}></img>
                </div>

                <Typography className="count shimmer-loader">
                  {overviewData ? (
                    overviewData.TotalNumberOfSurveys
                  ) : (
                    <ShimmerLoader></ShimmerLoader>
                  )}
                </Typography>
              </div>
            </CardContent>
          </Card>
          <Card className="overviewcard">
            <CardContent className="overviewcardcontent">
              <Typography>
                Number of people that answered on the 7th day
              </Typography>
              <div className="cardinfosec">
                <div className="imgbg">
                  <img src={imgurl.icon3}></img>
                </div>

                <Typography className="count shimmer-loader">
                  {overviewData ? (
                    overviewData.patient_seven_day
                  ) : (
                    <ShimmerLoader></ShimmerLoader>
                  )}
                </Typography>
              </div>
            </CardContent>
          </Card>
          <Card className="overviewcard">
            <CardContent className="overviewcardcontent">
              <Typography>
                Number of people that answered on the 14th day
              </Typography>
              <div className="cardinfosec">
                <div className="imgbg">
                  <img src={imgurl.icon3}></img>
                </div>

                <Typography className="count shimmer-loader">
                  {overviewData ? (
                    overviewData.patient_fourteen_day
                  ) : (
                    <ShimmerLoader></ShimmerLoader>
                  )}
                </Typography>
              </div>
            </CardContent>
          </Card>
          {/* comment due to :- IN-7279  */}
          {/* <Card className="overviewcard">
            <CardContent className="overviewcardcontent">
              <Typography>
                Number of new people onboarded in the previous month.
              </Typography>
              <div className="cardinfosec">
                <div className="imgbg">
                  <img src={imgurl.icon4}></img>
                </div>

                <Typography className="count shimmer-loader">
                  {overviewData ? (
                    overviewData.userOnboardedLastMonth
                  ) : (
                    <ShimmerLoader></ShimmerLoader>
                  )}
                </Typography>
              </div>
            </CardContent>
          </Card> */}
        </div>
        <hr class="divider" />

        <Filter />
        <hr class="divider" />
        <Charts isPayload={isPayload} chartNames={chartNames} />
      </div>
    </>
  );
}

export default Overview;
